import { render, staticRenderFns } from "./FactorBlock.vue?vue&type=template&id=6e8ac9b8&scoped=true"
import script from "./FactorBlock.vue?vue&type=script&lang=ts"
export * from "./FactorBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8ac9b8",
  null
  
)

export default component.exports